/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { useEffect, useRef } from "react";

import { connectSearchBox } from "react-instantsearch-dom";
import { useDispatch } from "react-redux";

import { ResetIcon } from "src/components/Search/Hits/Icons";
import { Tooltip } from "src/components/UI/Tooltip";
import { searchActions } from "src/store/modules/search";

import {
  SearchIconWrapper,
  StyledInput,
  ResetIconWrapper,
  Divider,
  CancelButton,
  SearchBarContainer,
  SearchBar,
} from "./SearchComponents";
import { SearchIcon } from "./SearchIcon";

interface Props {
  currentRefinement: string;
  isSearchStalled: boolean;
  refine: any;
}

const SearchBox = ({ currentRefinement, refine }: Props) => {
  const dispatch = useDispatch();

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleClose = () => {
    dispatch(searchActions.searchModalClosed({}));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code === "Escape") {
      e.preventDefault();
      handleClose();
    }
    if (e.code === "ArrowUp") {
      e.preventDefault();
      dispatch(searchActions.decrementFocusedResult());
    }
    if (e.code === "ArrowDown") {
      e.preventDefault();
      dispatch(searchActions.incrementFocusedResult());
    }
    if (e.code === "Enter") {
      dispatch(searchActions.gotToFocused());
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    refine(event.currentTarget.value);
    dispatch(searchActions.setFocusedResult(1));
  };

  return (
    <>
      <SearchBarContainer>
        <SearchBar>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInput
            placeholder="search plates & users"
            value={currentRefinement}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            ref={inputRef}
          />
          {currentRefinement !== "" && (
            <ResetIconWrapper onClick={() => refine("")}>
              <ResetIcon />
            </ResetIconWrapper>
          )}
          <Divider />
          <Tooltip tooltipText="Cancel (esc)">
            <CancelButton onClick={handleClose}>Cancel</CancelButton>
          </Tooltip>
        </SearchBar>
      </SearchBarContainer>
    </>
  );
};

export const CustomSearchBox: any = connectSearchBox(SearchBox);
